module.exports = __webpack_public_path__ + "static/img/ccod1.24fef00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod1.png
// module id = JCwr
// module chunks = 0